import { Plus, Minus } from "lucide-react";

export function ProsConsSection({ section }) {
  return (
    <div data-testid="typed-section-pros-cons" className="grid grid-cols-1 md:grid-cols-2 gap-3 my-3">
      <div className="rounded-lg border border-emerald-500/20 bg-emerald-500/5 p-3">
        <p className="text-xs font-mono uppercase tracking-widest text-emerald-500 mb-2">Pros</p>
        <ul className="space-y-1.5 text-sm">
          {section.pros.map((p, i) => (
            <li key={i} className="flex gap-2">
              <Plus className="h-3.5 w-3.5 text-emerald-500 mt-0.5 shrink-0" />
              {p}
            </li>
          ))}
        </ul>
      </div>
      <div className="rounded-lg border border-rose-500/20 bg-rose-500/5 p-3">
        <p className="text-xs font-mono uppercase tracking-widest text-rose-500 mb-2">Contras</p>
        <ul className="space-y-1.5 text-sm">
          {section.cons.map((c, i) => (
            <li key={i} className="flex gap-2">
              <Minus className="h-3.5 w-3.5 text-rose-500 mt-0.5 shrink-0" />
              {c}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
